import React from 'react';

/* Configure Sentry before rendering the React app */
require('../instrument');

import { createRoot } from 'react-dom/client';
import { PostHogErrorBoundary, PostHogProvider } from '@posthog/react';
import YesplanAppRoot from './containers/YesplanAppRoot';
import { installServiceWorker } from './libs/pwa';
import './assets/svg-icon-sprite.svg';
import IntlProviderDefaultMessages from './components/IntlProviderDefaultMessages';
import GlobalStyles from './GlobalStyles';
import { usePosthogForTenant, getTenantFromHost } from './libs/posthogAnalytics';

/* PostHog config is injected at runtime by the server via /config.js.
 * We only pass an apiKey when the current tenant should be tracked — this
 * prevents PostHogProvider from initialising on tenants like localhost or
 * testplan, matching the same logic previously in initPostHog. */
const posthogKey = usePosthogForTenant(getTenantFromHost(window.location.host))
  ? window.__POSTHOG_KEY__
  : undefined;

installServiceWorker();

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <PostHogProvider
    apiKey={posthogKey}
    options={{ api_host: window.__POSTHOG_HOST__, defaults: '2026-01-30' }}
  >
    <PostHogErrorBoundary>
      <>
        <GlobalStyles />
        <IntlProviderDefaultMessages locale="en">
          <YesplanAppRoot />
        </IntlProviderDefaultMessages>
      </>
    </PostHogErrorBoundary>
  </PostHogProvider>
);

// The code below is required for hot reloading
// if (module.hot) {
//   module.hot.accept('./containers/YesplanAppRoot', () => {
//     const NewRoot = require('./containers/YesplanAppRoot').default;
//     render(
//       <>
//         <GlobalStyles />
//         <AppContainer>
//           <IntlProviderDefaultMessages locale="en">
//             <NewRoot />
//           </IntlProviderDefaultMessages>
//         </AppContainer>
//       </>,
//       document.getElementById('root')
//     );
//   });
// }
